import map from 'lodash/map';
import { createSelector } from 'reselect';

const getSdkApplications = (state) => state.sdkApplications;
export const getSdkApplicationEntities = (state) => state.entities.sdkApplications;

export const getSdkApplicationsSelector = createSelector(
  [getSdkApplications, getSdkApplicationEntities],
  (sdkApplications, entities) => {
    const { sortedIds } = sdkApplications;
    return map(sortedIds, (id) => entities[id]);
  },
);
